<div id="banner">
    <img appLazyload [src]="img1" alt="banner" class="img-fluid w-100">
</div>